import { useCurrentOrganizationId } from 'hooks/use-current-organization-id';
import { useMemo } from 'react';
import type { VcsApi } from '@env0/vcs-service/api';
import useStores from 'hooks/use-stores.hooks';
import { apiBaseUrl } from 'constants/config';

type UseGetAuthorizationUrlProps = {
  connectionType: VcsApi.ConnectionType;
  vcsType: VcsApi.VcsType;
  authenticationType?: VcsApi.OAuthAuthenticationType;
};

export const useGetAuthorizationUrl = ({
  connectionType,
  vcsType,
  authenticationType
}: UseGetAuthorizationUrlProps) => {
  const organizationId = useCurrentOrganizationId();
  const { authStore } = useStores();

  return useMemo(() => {
    const url = new URL(`${apiBaseUrl}/vcs/oauth/start`);
    url.searchParams.append('organizationId', organizationId);
    url.searchParams.append('connectionType', connectionType);
    url.searchParams.append('vcsType', vcsType);
    // Callers that open the popup without the modal, like the TFC migration, get Entra too
    if (vcsType === 'AzureDevOps') url.searchParams.append('authenticationType', authenticationType ?? 'EntraOAuth');
    url.searchParams.append('token', authStore.getAccessToken()!);

    return url.toString();
  }, [organizationId, connectionType, vcsType, authenticationType, authStore]);
};
